import React from 'react';
// import { Link } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import phipa from '../assets/pipeda_and_phipa.png';
import gdpr from '../assets/gdpr.png';
import logo from '../assets/white_logo.png';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-10 px-10 md:px-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-6 gap-7">
        {/* Column 1: Logo & Description */}
        <div className="col-span-1">
        <div className="flex flex-col items-start gap-3">
          <img src={logo} alt="Cura AI Logo" className="h-13 w-auto -ml-3" />
          <p className="text-sm">
            Transforming healthcare with intelligent solutions.
          </p>
          <div className="flex gap-3 w-full">
  <img src={phipa} alt="PIPEDA and PHIPA" className="w-25 h-13 max-w-xs md:max-w-sm" />
  <img src={gdpr} alt="GDPR" className="w-13 h-13" />
</div>

        </div>
        </div>

        {/* Spacer */}
        <div className="hidden md:block" />

        {/* Spacer */}
        <div className="hidden md:block" />

        {/* Spacer */}
        <div className="hidden md:block" />

        {/* Column 2: Company */}
        {/* <div className="md:text-left">
          <h3 className="text-sm font-semibold text-white mb-2">Company</h3>
          <ul className="space-y-1 text-sm">
          <li >
            <Link smooth to="/#features" className="hover:underline">
              Products
            </Link>
          </li>
          <li>
            <Link smooth to="/#solutions" className="hover:underline">
              Solutions
            </Link>
          </li>
          <li>
            <Link smooth to="/#pricing" className="hover:underline">
              About
            </Link>
          </li>
          <li>
            <Link to="/privacy" className="hover:underline">
              HIPAA
            </Link>
          </li>
          <li>
            <Link to="/terms" className="hover:underline">
              EMR
            </Link>
          </li>
        </ul>
        </div> */}


        {/* Column 3: Resources */}
        {/* <div className="md:text-left">
          <h3 className="text-sm font-semibold text-white mb-2">Resources</h3>
          <ul className="space-y-1 text-sm">
          <li>
            <Link smooth to="/#features" className="hover:underline">
              Careers
            </Link>
          </li>
          <li>
            <Link smooth to="/#solutions" className="hover:underline">
              Research
            </Link>
          </li>
          <li>
            <Link smooth to="/#pricing" className="hover:underline">
              Blog
            </Link>
          </li>
          <li>
            <Link to="/privacy" className="hover:underline">
              Contact
            </Link>
          </li>
          <li>
            <Link to="/terms" className="hover:underline">
              Affiliate Program
            </Link>
          </li>
          <li>
            <Link to="/terms" className="hover:underline">
              Partner Program
            </Link>
          </li>
        </ul>
        </div> */}
        
        {/* Column 4: AI Agents */}
        {/* <div className="md:text-left">
          <h3 className="text-sm font-semibold text-white mb-2">AI Agents</h3>
          <ul className="space-y-1 text-sm">
          <li>
            <Link smooth to="/#features" className="hover:underline">
              AI Scribe
            </Link>
          </li>
          <li>
            <Link smooth to="/#solutions" className="hover:underline">
              AI Soap Notes
            </Link>
          </li>
          <li>
            <Link smooth to="/#pricing" className="hover:underline">
              AI Medical Dictation
            </Link>
          </li>
        </ul>
        </div> */}

        {/* Column 4: Quick Links */}
        <div className="md:text-left">
          <h3 className="text-sm font-semibold text-white mb-2">Quick Links</h3>
          <ul className="space-y-1 text-sm text-gray-300">
          <li>
            <Link smooth to="/#about" className="hover:underline">
              About
            </Link>
          </li>
          <li>
            <Link smooth to="/#features" className="hover:underline">
              Features
            </Link>
          </li>
          <li>
            <Link smooth to="/#solutions" className="hover:underline">
              Solutions
            </Link>
          </li>
          <li>
            <Link smooth to="/#pricing" className="hover:underline">
              Pricing
            </Link>
          </li>
          <li>
            <Link to="/privacy" className="hover:underline">
              Privacy
            </Link>
          </li>
          <li>
            <Link to="/terms" className="hover:underline">
              Terms
            </Link>
          </li>
        </ul>
        </div>

        {/* Column 3: Contact Us */}
        <div className="md:text-left">
          <h3 className="text-sm font-semibold text-white mb-2">Contact Us</h3>
          <p className="text-sm text-gray-300">
            <a href="mailto:info@curaai.ca" className="text-blue-600 hover:underline">info@curaai.ca</a>
          </p>
          {/* <p className="text-sm mt-1">
            Phone: <a href="tel:+16045555555" className="text-blue-600 hover:underline">+1 (604) 555-5555</a>
          </p> */}
          <p className="text-sm mt-1 text-gray-300">
            1200-555 <br/> West Hastings Street <br/> Vancouver, BC <br/> V6B 4N6
          </p>
        </div>
      </div>

      <div className="mt-10 text-center text-xs text-gray-450 border-t text-gray-300 border-gray-300 pt-4">
        <p>© 2025 Cura AI. All rights reserved.</p>
        <p>
          Made with <span className="text-red-500">❤️</span> in Vancouver, Canada
        </p>
      </div>
    </footer>
  );
};

export default Footer;